import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import {
	type RecentCollectionKey,
	RecentsRepository,
	type RemoveRecentInput,
	type RemoveRecentResult,
	type SetRecentInput,
	type SetRecentResult,
} from '@efficiently/client-api-recents';
import { GraphQLClient, GraphqlExecutorService } from '@efficiently/client-core-graphql';

import { CLEAR_ALL_RECENTS, GET_RECENTS, REMOVE_RECENT, SET_RECENT } from '../queries/recents.queries';

@Injectable()
export class RecentsGqlRepository extends RecentsRepository {
	private readonly gql = inject(GraphqlExecutorService);

	public override getRecents<T>(collectionKey: RecentCollectionKey): Observable<T[]> {
		return this.gql.query(GET_RECENTS, {
			variables: { collectionKey },
			client: GraphQLClient.Core,
			// `recents` is a JSON scalar (Array<unknown>); getRecents is a generic accessor,
			// so the caller supplies the concrete element type.
			select: data => (data.recents ?? []) as T[],
		});
	}

	public override setRecent(input: SetRecentInput): Observable<SetRecentResult> {
		return this.gql.mutate(SET_RECENT, {
			variables: { input },
			client: GraphQLClient.Core,
			select: data => data.setRecent,
		});
	}

	public override removeRecent(input: RemoveRecentInput): Observable<RemoveRecentResult> {
		return this.gql.mutate(REMOVE_RECENT, {
			variables: { input },
			client: GraphQLClient.Core,
			select: data => data.removeRecent,
		});
	}

	public override clearAllRecents(collectionKey: RecentCollectionKey): Observable<void> {
		return this.gql.mutate(CLEAR_ALL_RECENTS, {
			variables: { collectionKey },
			client: GraphQLClient.Core,
			select: (): void => undefined,
		});
	}
}
